import { User } from 'firebase/auth';
import { useEffect, useState } from 'react';
import { getLocalStorage } from 'utils/storage';
import { ADMIN_REGISTRATION_READY_EVENT } from 'utils/preview';
import useFirebase from './useFirebase';
import usePersonalDetails from './usePersonalDetails';

const useUser = () => {
  const { getAuth, isSignInWithEmailLink } = useFirebase();

  const [authFetched, setAuthFetched] = useState<boolean>(false);
  const [_user, setUser] = useState<User | null>(null);
  const [
    personalDetails,
    getPersonalDetails,
    token,
    setToken,
    setpersonalDetails,
    getUserAsync,
  ] = usePersonalDetails(_user);

  useEffect(() => {
    const auth = getAuth();
    // listen for auth state changes
    const listener = auth.onAuthStateChanged(async (user) => {
      if (user) {
        if (_user) return;
        setUser(user);
      } else {
        // if it's a magic link, wait for the user to sign in
        if (isSignInWithEmailLink(auth, window.location.href)) {
          return;
        }

        setUser(null);
        setAuthFetched(true);
      }
    });

    // unsubscribe on unmount
    return () => {
      listener();
    };
  }, [setAuthFetched, setUser, _user]);

  useEffect(() => {
    if (personalDetails && token) setAuthFetched(true);
  }, [personalDetails, token]);

  useEffect(() => {
    if (token) {
      getLocalStorage().setItem('brij-token', token);
    }
  }, [token]);

  // BD iframe: Firebase + in-memory token can survive localStorage.clear(); sync React state
  useEffect(() => {
    const clearSessionForAdminEmbed = () => {
      setUser(null);
      setToken(null);
      setpersonalDetails(null);
      setAuthFetched(false);
    };
    window.addEventListener(
      ADMIN_REGISTRATION_READY_EVENT,
      clearSessionForAdminEmbed
    );
    return () =>
      window.removeEventListener(
        ADMIN_REGISTRATION_READY_EVENT,
        clearSessionForAdminEmbed
      );
  }, [setToken, setpersonalDetails]);

  return {
    user: _user,
    setUser,
    personalDetails,
    getPersonalDetails,
    authFetched,
    token,
    setToken,
    setpersonalDetails,
    getUserAsync,
  };
};

export default useUser;
